export enum UserAction {
  BROWSE = 0,
  MANAGE = 1,
}
